export const RESET = 'giftTableFlow/RESET';

export const SET_CURRENT_STEP = 'giftTableFlow/SET_CURRENT_STEP';

export const SET_SELECTED_EVENT_TYPE = 'giftTableFlow/SET_SELECTED_EVENT_TYPE';

export const SAVE_GIFT_TABLE = 'giftTableFlow/SAVE_GIFT_TABLE';
export const SAVE_GIFT_TABLE_SUCCESS = 'giftTableFlow/SAVE_GIFT_TABLE_SUCCESS';
export const SAVE_GIFT_TABLE_FAILED = 'giftTableFlow/SAVE_GIFT_TABLE_FAILED';
